// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2h-my","title":"Images90_title__14Vz7","images":"Images90_images__2FOfk"};